import React from 'react';
import './svg.css';

const DataIcon = () => {
  return (

    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M5.34253 14.1625V8.03748H2.71753L8.18628 2.78748L13.655 8.03748H11.03V14.1625H5.34253V14.1625Z" stroke="#282828" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
      <path fillRule="evenodd" clipRule="evenodd" d="M16.7175 8.03748V14.1625H19.3425L13.8738 19.4125L8.40503 14.1625H11.03V8.03748H16.7175Z" stroke="#282828" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

  )
}

export default DataIcon;